/* PawRegal cart drawer add-ons. Pairs with snippets/pr-cart-addons.liquid.
   - One-tap offers: add (items + same portrait properties), swap (replace a line with another variant, same properties),
     rush (explicit consent step, records _rush_consent timestamp).
   - After every change the drawer re-renders from Shopify's section rendering (sections=cart-drawer,cart-icon-bubble).
   - Removing a portrait line also removes add-on lines tied to it via _for_upload_id (best effort).
   - Exposes window.PRCart.addItems(items) for the PDP AJAX add-to-cart. */
(function () {
  'use strict';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function drawer() { return document.querySelector('cart-drawer'); }
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status >= 400) throw new Error(j.description || j.message || 'Cart update failed'); return j; }); });
  }
  function sectionsUrl() { return window.location.pathname; }

  var ON_CART_PAGE = /^\/cart\/?$/.test(window.location.pathname);
  function render(state) {
    // first_sale 2026-11-01: the full cart page (product switcher, add-ons) re-renders by reloading after any change.
    if (ON_CART_PAGE) { window.location.reload(); return; }
    var d = drawer();
    if (d && state && state.sections) {
      // Dawn's product-form.js drops <cart-drawer>.is-empty before renderContents; our AJAX path must too, or a drawer
      // that loaded empty keeps its empty-state grid and the new line items collapse to 0 px (QA 2026-11-01).
      d.classList.remove('is-empty');
      d.renderContents(state);
      d.classList.toggle('is-empty', !!d.querySelector('.drawer__inner-empty'));
    }
    syncCount();
    autoFounding();
  }

  // Founding 200 (owner 2026-11-02): the ads promise a free matching ornament with a blanket, canvas or set, and the
  // BXGY only applies once the ornament is in the cart (order #1043 missed it). Liquid renders [data-pr-founding] only
  // while a qualifying line has no ORN3-1 yet; tap it once per portrait. A removed free ornament is never re-added.
  function autoFounding() {
    var btn = document.querySelector('[data-pr-founding]:not([disabled])');
    if (!btn) return;
    var key = 'pr_f200_' + btn.getAttribute('data-pr-founding');
    try { if (window.sessionStorage.getItem(key)) return; window.sessionStorage.setItem(key, '1'); } catch (e) { return; }
    btn.click();
  }
  function refresh() {
    return fetch(root + '?sections=' + SECTIONS).then(function (r) { return r.json(); }).then(function (sections) { render({ sections: sections }); });
  }
  function syncCount() {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-pr-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      var link = document.querySelector('[data-pr-cart-link]'); if (link) link.setAttribute('aria-label', 'Cart, ' + c.item_count + ' items');
    }).catch(function () {});
  }

  function portraitProps(json, skuId, label) {
    var p = {}; try { p = JSON.parse(json || '{}'); } catch (e) {}
    // Liquid `item.properties | json` serializes as [[key, value], ...], not an object (QA 2026-11-01: add-ons lost
    // _upload_id/_preview_url, so cards/ornaments/digital swaps had no portrait attached).
    if (Array.isArray(p)) { var o = {}; p.forEach(function (kv) { if (kv && kv.length === 2) o[kv[0]] = kv[1]; }); p = o; }
    var out = {};
    // Liquid hands property values over HTML-escaped ("&amp;sig=" in the signed _preview_url), so decode before reuse.
    var unesc = function (v) { return typeof v === 'string' ? v.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>') : v; };
    Object.keys(p).forEach(function (k) { if (k.charAt(0) === '_' && k.indexOf('_rush') !== 0 && k !== '_for_upload_id') out[k] = unesc(p[k]); });
    if (skuId) out._sku_id = skuId;
    if (label) out.Portrait = label;
    return out;
  }

  function applyDiscount(code) {
    // AJAX Cart API: /cart/update.js accepts `discount`. Fallback: GET /discount/CODE sets the checkout code cookie.
    return post('cart/update.js', { discount: code }).catch(function () {
      return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' });
    });
  }

  /** PDP + drawer entry point. items: [{id, quantity, properties}] */
  function addItems(items, opts) {
    opts = opts || {};
    var d = drawer();
    var body = { items: items };
    if (d) { body.sections = SECTIONS; body.sections_url = sectionsUrl(); }
    return post('cart/add.js', body).then(function (state) {
      var after = opts.discount ? applyDiscount(opts.discount).then(refresh) : Promise.resolve(render(state));
      return after.then(function () { if (d && opts.open !== false && !ON_CART_PAGE) d.open(); return state; });
    });
  }

  function swapLine(key, qty, variantId, props) {
    // Add the replacement first so the cart never empties, then drop one unit of the old line.
    // first_sale 2026-11-01: line keys can change when the add re-allocates discounts (flash code), so the old line is
    // re-found in /cart.js by its variant id + portrait (_upload_id/_style_id) before it is changed.
    var oldVariant = String(key).split(':')[0];
    return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: props }] })
      .then(function () { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) {
        var line = (c.items || []).filter(function (it) { return it.key === key; })[0] || (c.items || []).filter(function (it) {
          var p = it.properties || {};
          return String(it.variant_id) === oldVariant && String(it.variant_id) !== String(variantId) && (!props._upload_id || p._upload_id === props._upload_id) && (!props._style_id || p._style_id === props._style_id);
        })[0];
        if (!line) return refresh();
        return post('cart/change.js', { id: line.key, quantity: Math.max(0, Number(line.quantity) - 1), sections: SECTIONS, sections_url: sectionsUrl() }).then(render);
      });
  }

  function showErr(btn, msg) {
    var box = btn.closest('.pr-addons') && btn.closest('.pr-addons').querySelector('.pr-addons__err');
    if (box) { box.textContent = msg; box.hidden = false; }
  }

  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-pr-addon]');
    if (!btn) return;
    var kind = btn.getAttribute('data-pr-addon');
    if (kind === 'rush-open') {
      var box = document.getElementById(btn.getAttribute('aria-controls'));
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false'); if (box) box.hidden = !open;
      return;
    }
    ev.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true; btn.classList.add('is-busy');
    var p;
    if (kind === 'add') {
      var items = [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }];
      var props = portraitProps(btn.getAttribute('data-props'), btn.getAttribute('data-sku-id'), btn.getAttribute('data-label'));
      items.forEach(function (it) { it.properties = props; });
      p = addItems(items, { discount: btn.getAttribute('data-discount') || null });
    } else if (kind === 'swap') {
      var sp = portraitProps(btn.getAttribute('data-props'), btn.getAttribute('data-sku-id'), btn.getAttribute('data-label'));
      p = swapLine(btn.getAttribute('data-key'), btn.getAttribute('data-qty'), btn.getAttribute('data-variant'), sp);
    } else if (kind === 'rush') {
      p = addItems([{ id: Number(btn.getAttribute('data-variant')), quantity: 1, properties: { _rush: 'true', _rush_consent: new Date().toISOString(), _for_upload_id: btn.getAttribute('data-upload') || '' } }]);
    }
    if (p) p.catch(function (e) { btn.disabled = false; btn.classList.remove('is-busy'); showErr(btn, e.message || 'That did not work. Try again.'); });
  });

  // Header cart link opens the drawer when the drawer is enabled.
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-pr-cart-link]');
    var d = drawer();
    if (!a || !d) return;
    ev.preventDefault(); d.open(a);
  });

  // Orphaned add-ons: after Dawn changes quantities, drop add-on lines whose portrait is gone.
  var cleaning = false;
  function cleanOrphans() {
    if (cleaning) return; cleaning = true;
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var ups = {};
      c.items.forEach(function (it) { var p = it.properties || {}; if (p._upload_id && it.sku && it.sku.indexOf('CARD10') !== 0) ups[p._upload_id] = true; });
      var updates = {};
      var n = 0;
      c.items.forEach(function (it) {
        var p = it.properties || {};
        var orphanAddon = p._for_upload_id && !ups[p._for_upload_id];
        var orphanCard = it.sku && it.sku.indexOf('CARD10') === 0 && p._upload_id && !ups[p._upload_id];
        if (orphanAddon || orphanCard) { updates[it.key] = 0; n++; }
      });
      if (!n) return;
      return post('cart/update.js', { updates: updates, sections: SECTIONS, sections_url: sectionsUrl() }).then(render);
    }).catch(function () {}).then(function () { cleaning = false; });
  }
  // Dawn declares `subscribe` (function) and `PUB_SUB_EVENTS` (top-level const), so read them as bare globals.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'pr-addons') cleanOrphans(); });
  }

  // Add-on-only guard (owner profit fix 2026-11-01): holiday cards, extra pet, rush and extra-style lines are never
  // sold alone. Liquid already disables the checkout button (snippets/cart-drawer.liquid, main-cart-footer.liquid);
  // this re-checks the live cart on submit in case the markup is stale. Backstop: pipeline orders/paid guard.
  var PORTRAIT_SKU = /^(ORN3-1|BLK|CNV|SET-ORN-BLK|DIG)/;
  var ADDON_MSG = 'Holiday cards and other add-ons go with a portrait order. Add an ornament, blanket or canvas with your pet\'s portrait to check out.';
  function isAddonOnly(c) { return c.item_count > 0 && !c.items.some(function (it) { return PORTRAIT_SKU.test(it.sku || ''); }); }
  var checkoutOk = false;
  document.addEventListener('submit', function (ev) {
    var sub = ev.submitter;
    if (checkoutOk || !sub || sub.name !== 'checkout') return;
    ev.preventDefault();
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (isAddonOnly(c)) {
        var host = sub.closest('.cart__ctas') || sub.parentNode, p = host.querySelector('[data-pr-addon-only]');
        if (!p) { p = document.createElement('p'); p.className = 'pr-cart-guard'; p.setAttribute('role', 'alert'); p.setAttribute('data-pr-addon-only', ''); p.textContent = ADDON_MSG; host.insertBefore(p, sub); }
        sub.disabled = true; return;
      }
      checkoutOk = true;
      if (ev.target.requestSubmit) ev.target.requestSubmit(sub); else window.location.href = root + 'checkout';
    }).catch(function () { checkoutOk = true; if (ev.target.requestSubmit) ev.target.requestSubmit(sub); else window.location.href = root + 'checkout'; });
  }, true);

  autoFounding();

  window.PRCart = { isAddonOnly: isAddonOnly, addItems: addItems, swapLine: swapLine, refresh: refresh, cleanOrphans: cleanOrphans, syncCount: syncCount };
})();
